import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/admin/PageHeader";
import { Loader2 } from "lucide-react";
import { formatDateTime } from "@/lib/format";

export default function ActivityLog() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/activity").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div>
      <PageHeader title="Activity log" subtitle="Audit trail of administrator actions" />
      <div className="bg-white rounded-xl border border-border overflow-hidden">
        {items === null ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-[#C81D35] animate-spin" /></div>
          : items.length === 0 ? <div className="text-center py-16 text-muted-foreground">No activity recorded yet.</div>
          : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground border-b border-border"><th className="p-4 font-medium">Action</th><th className="p-4 font-medium">Admin</th><th className="p-4 font-medium">Entity</th><th className="p-4 font-medium">When</th></tr></thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-b border-border/60 last:border-0" data-testid={`activity-${a.id}`}>
                  <td className="p-4 text-[#111827]">{a.summary || a.action}</td>
                  <td className="p-4 text-muted-foreground">{a.user_name || "—"}</td>
                  <td className="p-4 text-muted-foreground">{a.entity_type || "—"}</td>
                  <td className="p-4 text-muted-foreground whitespace-nowrap">{formatDateTime(a.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
